import * as React from 'react';

import { styled } from '@mui/material/styles';
import {
  tableCellClasses,
  TableCell,
  TableContainer,
  Table,
  TableRow,
  TableBody,
  Stack,
  Box,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { WheelsVehicle } from '../../domain/wheels';
import { VechicleRoute } from './use-wheels-routes-table';

// ********************************************************************************
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#F3F2F5',
    color: '#3F2A55',
    fontFamily: 'Gotham-Bold',
  },
  [`&.${tableCellClasses.body}`]: {
    fontFamily: 'Gotham-Medium',
  },
  fontSize: 12,
  maxWidth: '100px',
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#F3F2F5',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

type Props = {
  type: WheelsVehicle;
  data: VechicleRoute[];
};
export const WheelsRouteTable: React.FC<Props> = ({ type, data }) => {
  const { t } = useTranslation();
  const headers: Record<WheelsVehicle, string> = {
    [WheelsVehicle.Sedan]: 'wheels_service.wheels_price.routes.sedan',
    [WheelsVehicle.Suv]: 'wheels_service.wheels_price.routes.suv',
    [WheelsVehicle.Transit]: 'wheels_service.wheels_price.routes.transit',
  };
  // == Render =====================================================================
  return (
    <Stack spacing={2} sx={{ width: '100%', maxWidth: '365px'}}>
      <Box display="flex" justifyContent="center" alignItems="center" gap={1} mb={2}>
        <img src={`/images/WheelsPrice/${type}.png`} style={{ height: 85, backgroundSize: 'cover' }}></img>
        <Typography variant="h3" color="#3F2B56" fontFamily="Gotham-Medium" fontSize="1em" align="left">
          {t(headers[type])}
        </Typography>
      </Box>
      <TableContainer>
        <Table aria-label="wheels table" size="small">
          <TableBody>
            {data.map((row) => (
              <StyledTableRow key={row.zone}>
                <StyledTableCell component="th" scope="row" sx={{ minWidth: '130px' }}>
                  {row.zone}
                </StyledTableCell>
                <StyledTableCell
                  sx={{
                    maxWidth: '60px',
                    color: '#3F2A55 !important',
                    fontFamily: 'Gotham-Bold !important',
                    textAlign: 'end',
                  }}
                >
                  {row.price === 0 ? '-' : `$${row.price}`}
                </StyledTableCell>{' '}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
};
